import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { OrchestrationRunState, OrchestrationRunStore } from './orchestration-run.store';

@Injectable({ providedIn: 'root' })
export class OrchestrationRunQuery extends QueryEntity<OrchestrationRunState> {
  constructor(protected store: OrchestrationRunStore) {
    super(store);
  }
}
